import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/admin/services/user.service';
import { AppUtils } from 'src/app/helpers/app.utils';
import { PageUrls } from 'src/app/helpers/page-urls';
import { CountryService } from 'src/app/services/country.service';
import { EditorEditModel } from 'src/app/admin/models/editor.edit.model';
import { Constants } from 'src/app/helpers/constants';

@Component({
    selector: 'app-user-edit-editor',
    templateUrl: './user.edit.editor.component.html'
})
export class UserEditEditorComponent implements OnInit {
    isModelLoaded = false;
    emailPattern = '[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$';
    phoneMask: string;
    model: EditorEditModel = new EditorEditModel();

    get urls() {
        return PageUrls;
    }

    constructor(private router: Router, private route: ActivatedRoute,
        private ngxSpinner: NgxSpinnerService,
        private toastr: ToastrService, private countryService: CountryService,
        private userService: UserService) {
    }

    ngOnInit() {
        this.model.id = this.route.snapshot.queryParams.editorId;
        this.phoneMask = Constants.phoneMask;
        this.getEditor();
    }

    getEditor() {
        this.isModelLoaded = false;
        this.ngxSpinner.show();
        this.userService.getEditor(this.model.id)
            .subscribe(data => {
                Object.assign(this.model, data);
                this.ngxSpinner.hide();
                this.isModelLoaded = true;
            }, error => {
                this.ngxSpinner.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }

    submit() {
        this.ngxSpinner.show();
        this.userService.editEditor(this.model).subscribe(
            () => {
                this.ngxSpinner.hide();
                this.router.navigateByUrl(`${PageUrls.Admin.UserEditor}`);
                setTimeout(() => {
                    this.toastr.success('Editor has been updated successfully.');
                });
            },
            error => {
                this.ngxSpinner.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }
}
